/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



$(document).ready(function(){
  // Remove app search section from page to run custom block 
  // $(".shopify-block.shopify-app-block").remove();
});

$(document).ready(function(){
  if($("body").hasClass("ymm-custom")){
    var searchResultTimer = setInterval(function(){
      if($(".ymm-result-page #products .grid__item").length){
        if($(".ymm-result-page #products .grid__item").length != $(".ymm-result-page #products .content_loaded").length){
          clearInterval(searchResultTimer);
          setSearchProductData();
        }

        var title_ymm = "Search Results For ";
        $("ul.dropdowns:visible li").each(function(){
          title_ymm += $(this).find("select option:selected").text() + " ";
        });
        $("h2.title-ymm").text(title_ymm);
        $("img.ymm-image-car").hide();

      }
    },1000);
  }
  initSelect2Dropdown();
});

function setSearchProductData(){
  var through_bar_html = "";
  var flush_bar_html = "";
  var hd_bar = "";
  $("#products .grid__item:not(.content_loaded)").each(function(){
      console.log(111)
      $(this).find(".ymm-product-item .product-thumb").wrap("<div class='list-left'></div>");
      $(this).find(".ymm-product-item > *:not(.list-left)").wrapAll("<div class='list-right'></div>");
      $(this).find(".ymm-product-item > *").wrapAll("<div class='list-wrap'></div>");
  
      var proURL = $(this).find(".grid-view-item__title a").attr("href");
        $(this).find(".grid-view-item__meta").after('<a href="'+proURL+'" class="btn product-form__add-button button button--primary buy-now-btn">BUY NOW</a>');
  
      
      var pTitle = $(this).find(".grid-view-item__title a").text().toLowerCase();
      if(pTitle.indexOf("flush") != -1 || pTitle.indexOf("rail") != -1){
        $(this).find(".grid-view-item__title").after("<div class='item__desc'><ul><li>Low profile roof rack</li><li>Neat and stylish look</li><li>Vehicle specific fit</li></ul></div>") ;
        flush_bar_html += $(this).clone().wrap("<div />").parent().html();
      }else if(pTitle.indexOf("hd") != -1){
        $(this).find(".grid-view-item__title").after("<div class='item__desc'><ul><li>Extra load rating</li><li>Plenty of width for wide loads</li><li>Huge range of load accessories</li><li>Fits almost all roof rack accessories</li></ul></div>");
        hd_bar += $(this).clone().wrap("<div />").parent().html();
      }else if(pTitle.indexOf("+ timberline fx legs") != -1){
        $(this).find(".grid-view-item__title").after("<div class='item__desc'><ul><li>Sleek flush-bar design for a modern, factory-finished look</li><li>Aerodynamic JetFlow™ shape reduces wind noise and drag</li><li>Fits vehicles with raised roof rails securely</li><li>Tool-free installation using durable rubber-coated straps</li></ul></div>");
        hd_bar += $(this).clone().wrap("<div />").parent().html();
      }else if(pTitle.indexOf("+ sightline fx legs") != -1){
        $(this).find(".grid-view-item__title").after("<div class='item__desc'><ul><li>Sleek flush-bar design for a modern, factory-finished look</li><li>Aerodynamic JetFlow™ shape reduces wind noise and drag</li><li>Custom-fit design for flush-mounted roof rails</li><li>Installs easily with vehicle-specific SightClips</li></ul></div>");
        hd_bar += $(this).clone().wrap("<div />").parent().html();
      }else if(pTitle.indexOf("+ skyline fx legs") != -1){
        $(this).find(".grid-view-item__title").after("<div class='item__desc'><ul><li>Sleek flush-bar design for a modern, factory-finished look</li><li>Aerodynamic JetFlow™ shape reduces wind noise and drag</li><li>Fits vehicles with fixed points or track systems</li><li>Quick, secure installation with Yakima Landing Pads</li></ul></div>");
        hd_bar += $(this).clone().wrap("<div />").parent().html();
      }else if(pTitle.indexOf("+ baseline fx legs") != -1){
        $(this).find(".grid-view-item__title").after("<div class='item__desc'><ul><li>Sleek flush-bar design for a modern, factory-finished look</li><li>Aerodynamic JetFlow™ shape reduces wind noise and drag</li><li>Designed for bare-roof vehicles</li><li>Secure fit using vehicle-specific BaseClips</li></ul></div>");
        hd_bar += $(this).clone().wrap("<div />").parent().html();
      }else if(pTitle.indexOf("+ timberline legs") != -1){
        $(this).find(".grid-view-item__title").after("<div class='item__desc'><ul><li>Continuous bar design provides extra carrying width</li><li>Aerodynamic JetFlow™ shape minimises drag and wind noise</li><li>Fits vehicles with raised roof rails securely</li><li>Tool-free installation with strong rubber-coated straps</li></ul></div>");
        hd_bar += $(this).clone().wrap("<div />").parent().html();
      }else if(pTitle.indexOf("+ sightline legs") != -1){
        $(this).find(".grid-view-item__title").after("<div class='item__desc'><ul><li>Continuous bar design provides extra carrying width</li><li>Aerodynamic JetFlow™ shape minimises drag and wind noise</li><li>Designed for flush-mounted roof rails</li><li>Easy installation with vehicle-specific SightClips</li></ul></div>");
        hd_bar += $(this).clone().wrap("<div />").parent().html();
      }else if(pTitle.indexOf("+ skyline legs") != -1){
        $(this).find(".grid-view-item__title").after("<div class='item__desc'><ul><li>Continuous bar design provides extra carrying width</li><li>Aerodynamic JetFlow™ shape minimises drag and wind noise</li><li>Ideal for vehicles with fixed points or track systems</li><li>Secure fit with Yakima Landing Pads</li></ul></div>");
        hd_bar += $(this).clone().wrap("<div />").parent().html();
      }else if(pTitle.indexOf("+ baseline legs") != -1){
        $(this).find(".grid-view-item__title").after("<div class='item__desc'><ul><li>Continuous bar design provides extra carrying width</li><li>Aerodynamic JetFlow™ shape minimises drag and wind noise</li><li>Designed for bare-roof vehicles</li><li>Vehicle-specific BaseClips ensure a perfect fit</li></ul></div>");
        hd_bar += $(this).clone().wrap("<div />").parent().html();
      }else{
        $(this).find(".grid-view-item__title").after("<div class='item__desc'><ul><li>Low profile roof rack</li><li>More width for extra room</li><li>Fit multiple vehicles</li></ul></div>");
        through_bar_html += $(this).clone().wrap("<div />").parent().html();
      }
      $(this).addClass("content_loaded");
  });
}

function initSelect2Dropdown(){
 /* setInterval(function(){
    if($("ul.dropdowns li").length){
      $("ul.dropdowns li").each(function(){
        var selObj = $(this).find("select");
        if(selObj.length){           
          if(!selObj.hasClass("select2-hidden-accessible") && selObj.attr("disabled") == undefined){
            selObj.select2({
              selectOnClose: true
            });
          }
        }
      });    
    }
  },1000);*/
}
